import "../css/header.scss";
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "./CartContext";

function Header() {
  const { cartItems } = useContext(CartContext);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <header className="site-header">
      <div className="header-container">
        <Link to="/" className="logo" onClick={toTop}>
          <svg
            className="logo-mark"
            viewBox="0 0 52 52"
            role="img"
            aria-labelledby="mefurvexo-logo-title"
          >
            <title id="mefurvexo-logo-title">mefurvexo home</title>
            <path className="logo-frame" d="M26 2 50 26 26 50 2 26Z" />
            <path className="logo-letter" d="M13 35V16l13 12 13-12v19" />
            <circle className="logo-jewel" cx="26" cy="11" r="2.2" />
          </svg>
        </Link>
        <nav className="main-nav">
          <div className="nav-item">
            <Link to="/shop" onClick={toTop}>
              SHOP
            </Link>
          </div>
          <div className="nav-item">
            <Link to="/about" onClick={toTop}>
              ABOUT
            </Link>
          </div>
          <div className="nav-item">
            <Link to="/contact" onClick={toTop}>
              CONTACT
            </Link>
          </div>
          <details className="nav-item more-menu">
            <summary>
              MORE <span className="dropdown-icon">⌄</span>
            </summary>
            <div className="more-dropdown">
              <Link to="/policies" onClick={toTop}>POLICY CENTRE</Link>
              <Link to="/privacy" onClick={toTop}>PRIVACY</Link>
              <Link to="/cookies" onClick={toTop}>COOKIES</Link>
              <Link to="/faqs" onClick={toTop}>FAQS</Link>
              <Link to="/terms" onClick={toTop}>TERMS</Link>
              <Link to="/returns" onClick={toTop}>RETURNS</Link>
              <Link to="/shipping" onClick={toTop}>SHIPPING</Link>
            </div>
          </details>
        </nav>
        <div className="header-actions">
          <Link to="/cartpage" className="action-btn cart-btn" onClick={toTop}>
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
              <line x1="3" y1="6" x2="21" y2="6" />
            </svg>
            {cartItems.length > 0 && (
              <span className="cart-count">{cartItems.length}</span>
            )}
          </Link>
        </div>
      </div>
    </header>
  );
}

export default Header;
